import React from 'react';

import SizeBadge from '../../library/size-badge/size-badge';
import Typography from '../../library/typography/typography';

import { toInches } from '../../shared/utils/text/text';

import './fitment-size.scss';

const formatTireSize = size => size && size.replace('-', ' ');

interface FitmentSizeProps {
  className?: string;
  isOE?: boolean;
  rideHeightType?: string;
  sizeQualifier?: string;
  tireLocation?: string;
  tireSize?: string;
  wheelDiameter?: string;
}

function FitmentSize(props: FitmentSizeProps) {
  const {
    isOE,
    rideHeightType,
    sizeQualifier,
    tireLocation,
    tireSize,
    wheelDiameter
  } = props;

  let tireLabelPrefix: string;

  if (rideHeightType && !isOE) {
    tireLabelPrefix = rideHeightType.toLowerCase();
  } else if (isOE) {
    tireLabelPrefix = 'factory';
  } else {
    tireLabelPrefix = 'optional';
  }

  return (
    <>
      {(isOE || sizeQualifier) && (
        <SizeBadge isOE={isOE} sizeQualifier={sizeQualifier} />
      )}

      {Boolean(tireSize) && (
        <div className="fitment-size__tire" styleName="tire">
          <Typography
            className="fitment-size__size"
            styleName="size"
            tag="span"
            weight="bold"
          >
            {formatTireSize(tireSize)}
          </Typography>

          {(rideHeightType || isOE || sizeQualifier) && (
            <Typography
              className="fitment-size__type-label"
              size="small"
              styleName="type-label"
              tag="span"
            >
              {tireLabelPrefix}{' '}
              {tireLocation ? `${tireLocation} tire` : 'tire size'}
            </Typography>
          )}
        </div>
      )}

      {Boolean(wheelDiameter) && (
        <div className="fitment-size__wheel" styleName="wheel">
          <Typography
            className="fitment-size__wheel-size"
            styleName="size"
            tag="span"
            weight="bold"
          >
            {toInches(wheelDiameter)}
          </Typography>
          <Typography
            className="fitment-size__wheel-type-label"
            size="small"
            styleName="type-label"
            tag="span"
          >
            wheels
          </Typography>
        </div>
      )}
    </>
  );
}

export default FitmentSize;
